import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import * as Config from "../utils/ConfigurationRegistry";
import BulkEditDialog from "./BulkEditDialog";
function getChildPathByIndex(path, childKey, index) {
  if (childKey) {
    return "".concat(path, ":").concat(childKey, "[").concat(index, "]");
  }
  return null;
}

/**
 * All configuration values are assumed to be identified by the same path with key 'childKey'
 * and an index (ie. path:childKey[index]). New entries can be created/deleted by this dialog.
 */
var ConfigurationBulkEditDialog = function ConfigurationBulkEditDialog(_ref) {
  var path = _ref.path,
    childKey = _ref.childKey,
    inputColumns = _ref.columns,
    title = _ref.title,
    open = _ref.open,
    handleCancel = _ref.handleCancel;
  var columns = inputColumns;
  if (childKey) {
    var config = Config.getDefault(path + ":" + childKey);
    columns = columns.map(function (column) {
      var childConfig = Config.getChild(config, column.key, true);
      var columnWithLabel = _objectSpread({}, column);
      columnWithLabel.label = childConfig.data.label;
      return columnWithLabel;
    });
  }
  var allowAddOrRemove = true;
  var handleApplyBulkEdit = function handleApplyBulkEdit(lines, ignoredColumns) {
    var i;
    for (i = 0; i < lines.length; i++) {
      var _config = Config.fromPath(path, false, true);
      var line = lines[i];
      var words = line.split("\t");
      var exists = i < _config.children.length;
      if (!exists) {
        if (!allowAddOrRemove) {
          break;
        }
        var newItem = Config.getDefault(getChildPathByIndex(path, childKey, i));
        newItem.children.map(function (child) {
          return child.children = [];
        });
        Config.addChild(_config, newItem);
      }
      var wordIndex = 0;
      for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        var column = columns[columnIndex];
        if (ignoredColumns.includes(column)) {
          continue;
        }
        Config.setDataValue("".concat(getChildPathByIndex(path, childKey, i), ":").concat(column.key), words[wordIndex]);
        wordIndex++;
      }
    }
    var config = Config.fromPath(path);
    if (config) {
      for (i = config.children.length - 1; i >= lines.length; i--) {
        if (allowAddOrRemove) {
          Config.deleteChild(path, i);
        } else {
          // Reset values to null
          for (var _columnIndex = 0; _columnIndex < columns.length; _columnIndex++) {
            Config.setDataValue("".concat(getChildPathByIndex(path, childKey, i), ":").concat(columns[_columnIndex].key), null);
          }
        }
      }
    }
    handleCancel();
  };
  var getBulkEditLines = function getBulkEditLines() {
    var config = Config.fromPath(path);
    if (!config) {
      return [];
    }
    var children = config.children;
    return children.reduce(function (current, child) {
      current.push(columns.map(function (column) {
        var grandchild = child.children.find(function (grandchild) {
          return grandchild.key === column.key;
        });
        return grandchild ? grandchild.data.value : "";
      }).join("\t"));
      return current;
    }, []);
  };
  return /*#__PURE__*/React.createElement(BulkEditDialog, {
    keepEmptyLines: !allowAddOrRemove,
    title: title,
    open: open,
    columns: columns,
    handleCancel: handleCancel,
    handleApply: handleApplyBulkEdit,
    data: getBulkEditLines()
  });
};
export default ConfigurationBulkEditDialog;